import { render } from "./SystemUser.vue?vue&type=template&id=418f636e"
import script from "./SystemUser.vue?vue&type=script&lang=js"
export * from "./SystemUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__